/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import {useEffect, useState} from 'react';
import {Button, Accordion} from 'react-bootstrap';
// eslint-disable-next-line import/named
import {confirmAlert} from 'react-confirm-alert';
import {toast} from 'react-toastify';
import CustomListGroupCondition from 'components/Custom/ListGroup/CustomListGroupCondition';
import CustomSelectionItemCondition from './CustomSelectionItemCondition';
import {
	defaultFormDataCondition,
	transformLabelConditions,
	labelConditions,
	resolveFieldKey,
	setNestedField,
	getNestedField,
	labelToFieldMap,
} from './utils/InitConditionLabels';
import {cleanConditionFormForXML, generateUUID} from 'utils';
import {useAppSelector} from 'store/hooks';

import type {
	ConditionObject,
	IServingNetwork,
	IConditionForm,
	Xml2Js,
} from 'interfaces';

type TProps = {
	onChange: (arg: Xml2Js) => void;
	rowData: Xml2Js;
	typeForm: string;
	onObserver: (isValid: boolean) => void; // validator submit btn
};

const ConditionForm = ({onChange, rowData, typeForm, onObserver}: TProps) => {
	const [formData, setFormData] = useState<IConditionForm[]>([]);

	const {state: stateSystem} = useAppSelector(
		state => state.systemConfigProperty,
	);

	const isVolTE = stateSystem === 'VolTE';

	let orCount = 0;

	const handleConditionAdd = (typeCondition: boolean) => {
		setFormData(prev => {
			if (
				typeCondition === false &&
				prev.some(condition => condition.isGroup === false)
			) {
				toast.warning(
					'There can only be one aggregated AND group under the conditions.',
				);
				return prev;
			}

			const newCondition: IConditionForm = {
				...defaultFormDataCondition(),
				isGroup: typeCondition,
			};

			return [...prev, newCondition];
		});
	};

	const handleRemoveCondition = (idToRemove: string) => {
		setFormData(prevFormData =>
			prevFormData.filter(condition => condition.id !== idToRemove),
		);
	};

	const removeAccordion = (idToRemove: string) => ({
		title: 'Do you really want to remove this group?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						handleRemoveCondition(idToRemove);
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	// default values
	useEffect(() => {
		if (!rowData?.conditions) return;
		const normalizeInput = (condition: any): any => {
			const normalized: any = {};
			for (const key in condition) {
				const value = condition[key];

				if (key === 'isGroup') {
					normalized[key] = value;
				} else if (Array.isArray(value)) {
					// Si es array, déjalo tal cual
					normalized[key] = value;
				} else if (
					typeof value === 'object' &&
					value !== null &&
					Object.keys(value).every(k => !isNaN(Number(k)))
				) {
					// Objeto con keys numéricas, convertimos a array
					normalized[key] = Object.values(value);
				} else {
					// Si es objeto y NO es array ni objeto numérico, dejarlo como está
					normalized[key] = value;
				}
			}
			return normalized;
		};

		const tmpFormData = rowData.conditions.map(condition =>
			defaultFormDataCondition(normalizeInput(condition)),
		);

		setFormData(tmpFormData);
	}, [rowData]);

	const handleFieldSelect = (id: string, ...path: string[]) => {
		const resetToDefault = (prevFormData: IConditionForm, keys: string[]) => {
			const defaultData = defaultFormDataCondition();
			const defaultValue = getNestedField(defaultData, keys);
			if (defaultValue === undefined) return prevFormData;
			return setNestedField(prevFormData, keys, defaultValue);
		};

		const selectedLabel = path[path.length - 1];

		setFormData(prevFormData =>
			prevFormData.map(condition => {
				if (condition.id !== id) return condition;

				// CASO ESPECIAL: ServingNetwork
				if (selectedLabel === 'MNC / MCC') {
					const updatedServingNetwork = condition.servingNetwork.map(sn => ({
						mcc: {
							...sn.mcc,
							active: !sn.mcc.active,
							notChecked: !sn.mcc.active ? sn.mcc.notChecked : false,
						},
						mnc: {
							...sn.mnc,
							active: !sn.mnc.active,
							notChecked: !sn.mnc.active ? sn.mnc.notChecked : false,
						},
					}));

					// Verifica si todos los campos están desactivados
					const allInactive = updatedServingNetwork.every(
						sn => !sn.mcc.active && !sn.mnc.active,
					);

					if (allInactive) {
						return resetToDefault(condition, ['servingNetwork']);
					}
					return {
						...condition,
						servingNetwork: updatedServingNetwork,
					};
				}

				const fieldNameConvert = resolveFieldKey(...path);
				if (!fieldNameConvert) return condition;

				if (Array.isArray(fieldNameConvert)) {
					const [parentKey, ...nestedKeys] = fieldNameConvert;
					const baseValue = condition[parentKey as keyof IConditionForm];

					// Detecta si es array de objetos complejos (como tai, servingNetwork, etc.)
					if (
						Array.isArray(baseValue) &&
						baseValue.length > 0 &&
						typeof baseValue[0] === 'object' &&
						baseValue[0] !== null
					) {
						const updatedArray = baseValue.map(item => {
							const field = getNestedField<ConditionObject<any>>(
								item,
								nestedKeys,
							);
							if (field && 'active' in field) {
								const updatedField = {
									...field,
									active: !field.active,
									notChecked: !field.active ? field.notChecked : false,
								};
								return setNestedField(item, nestedKeys, updatedField);
							}
							return item;
						});

						// Si ningún subcampo en ningún objeto tiene active === true, se debe resetear el campo
						const someActiveExists = updatedArray.some(obj => {
							// Busca recursivamente si existe algún `ConditionObject` con active: true
							const checkAnyActive = (value: any): boolean => {
								if (!value || typeof value !== 'object') return false;

								if ('active' in value && typeof value.active === 'boolean') {
									return value.active;
								}

								// Si es objeto anidado, recorre sus propiedades
								return Object.values(value).some(checkAnyActive);
							};

							return checkAnyActive(obj);
						});

						if (!someActiveExists) {
							const updatedCondition = resetToDefault(condition, [parentKey]);
							return {
								...condition,
								[parentKey]: getNestedField(updatedCondition, [parentKey]),
							};
						}

						return {
							...condition,
							[parentKey]: [...updatedArray],
						};
					}

					// Caso normal (no es array complejo)
					const currentField = getNestedField<ConditionObject<any>>(condition, [
						parentKey,
						...nestedKeys,
					]);

					if (!currentField) return condition;

					const updatedField = {
						...currentField,
						active: !currentField.active,
						notChecked: !currentField.active ? currentField.notChecked : false,
					};

					if (!updatedField.active) {
						return resetToDefault(condition, [parentKey, ...nestedKeys]);
					}

					return setNestedField(
						condition,
						[parentKey, ...nestedKeys],
						updatedField,
					);
				}

				const key = fieldNameConvert as keyof IConditionForm;
				const current = condition[key];

				if (
					Array.isArray(current) &&
					current.length > 0 &&
					typeof current[0] === 'object' &&
					current[0] !== null &&
					'active' in current[0]
				) {
					const updatedArray = [...(current as ConditionObject<any>[])];

					const first = updatedArray[0];
					updatedArray[0] = {
						...first,
						active: !first.active,
						notChecked: !first.active ? first.notChecked : false,
					};

					if (!updatedArray[0].active) {
						const updatedCondition = resetToDefault(condition, [key]);
						return {
							...condition,
							[key]: getNestedField(updatedCondition, [key]),
						};
					}

					return {
						...condition,
						[key]: updatedArray,
					};
				}

				if (typeof current === 'object' && current && 'active' in current) {
					const updatedField = {
						...current,
						active: !current.active,
						notChecked: !current.active ? current.notChecked : false,
					};

					if (!updatedField.active) {
						return resetToDefault(condition, [key]);
					}

					return {
						...condition,
						[key]: updatedField,
					};
				}

				return condition;
			}),
		);
	};

	const updateFormData = (
		keyForm: string,
		path: string[],
		value: string,
		type: string,
		checked: boolean,
		key: number | null,
		data: string[] | undefined,
	) => {
		const valueField = type === 'checkbox' ? checked : value;
		const deepUpdate = (obj: any, tags: string[], valueArg: any): any => {
			if (!tags.length) return obj;
			const [current, ...rest] = tags;

			if (rest.length === 0) {
				const field = obj?.[current];

				if (field && typeof field === 'object' && 'value' in field) {
					return {
						...obj,
						[current]: {
							...field,
							value: valueArg,
						},
					};
				}
				return obj;
			}

			return {
				...obj,
				[current]: deepUpdate(obj?.[current] ?? {}, rest, valueArg),
			};
		};

		setFormData(prevFormData =>
			prevFormData.map(condition => {
				if (condition.id !== keyForm) return condition;
				if (
					(type === 'text' ||
						type === 'number' ||
						type === 'select-one' ||
						type === 'checkbox') &&
					key === null
				) {
					return deepUpdate(condition, path, valueField);
				}

				// para los array como time1, roaming1
				if (key !== null && Number.isInteger(key)) {
					const keyField = path[0] as keyof IConditionForm;
					const arrayField = condition[keyField];

					if (Array.isArray(arrayField)) {
						const innerPath = path.slice(1);
						const updatedArray = arrayField.map((item, i) => {
							if (i !== key) return item;

							if (innerPath.length === 0) {
								if (typeof item === 'object' && 'value' in item) {
									return {
										...item,
										value: valueField,
									};
								}
								return item;
							}

							return deepUpdate(item, innerPath, valueField);
						});

						return {
							...condition,
							[path[0]]: updatedArray,
						};
					}
				}
				return condition;
			}),
		);
	};

	const updateNotChecked = (
		id: string,
		path: string[],
		key?: number | null,
	) => {
		setFormData(prevFormData =>
			prevFormData.map(condition => {
				if (condition.id !== id) return condition;

				const keyField = path[0] as keyof IConditionForm;

				// Caso especial: servingNetwork
				if (keyField === 'servingNetwork' && typeof key === 'number') {
					const updatedServing = condition.servingNetwork.map((item, index) => {
						if (index !== key) return item;

						return {
							mcc: {
								...item.mcc,
								notChecked: !item.mcc.notChecked,
							},
							mnc: {
								...item.mnc,
								notChecked: !item.mnc.notChecked,
							},
						};
					});

					return {
						...condition,
						servingNetwork: updatedServing,
					};
				}

				const arrayField = condition[keyField];

				if (
					Array.isArray(arrayField) &&
					typeof key === 'number' &&
					arrayField.length > 0 &&
					typeof arrayField[key] === 'object' &&
					!(
						'value' in arrayField[key] &&
						'active' in arrayField[key] &&
						'notChecked' in arrayField[key]
					)
				) {
					const current = arrayField[key];
					let newNotChecked = true;
					const findNotChecked = (obj: any): boolean | null => {
						if (obj && typeof obj === 'object') {
							for (const k in obj) {
								if (obj[k] && typeof obj[k] === 'object') {
									if ('notChecked' in obj[k]) return !obj[k].notChecked;
									const nested = findNotChecked(obj[k]);
									if (nested !== null) return nested;
								}
							}
						}
						return null;
					};

					const toggleValue = findNotChecked(current);
					if (toggleValue !== null) {
						newNotChecked = toggleValue;
					}

					const recursiveToggle = (obj: any): any => {
						if (obj && typeof obj === 'object') {
							const copy = {...obj};
							for (const k in copy) {
								if (
									copy[k] &&
									typeof copy[k] === 'object' &&
									'notChecked' in copy[k]
								) {
									copy[k] = {
										...copy[k],
										notChecked: newNotChecked,
									};
								} else if (typeof copy[k] === 'object') {
									copy[k] = recursiveToggle(copy[k]);
								}
							}
							copy.notChecked = newNotChecked;
							return copy;
						}
						return obj;
					};

					const updatedArray = [...arrayField];
					updatedArray[key] = recursiveToggle(arrayField[key]);

					return {...condition, [keyField]: updatedArray};
				}

				// Si es array de ConditionObject<T>
				if (
					key !== null &&
					Array.isArray(arrayField) &&
					arrayField.length > 0 &&
					typeof arrayField[0] === 'object' &&
					arrayField[0] !== null &&
					'notChecked' in arrayField[0]
				) {
					const updatedArray = (arrayField as ConditionObject<any>[]).map(
						(item, index) =>
							index === key ? {...item, notChecked: !item.notChecked} : item,
					);

					return {
						...condition,
						[keyField]: updatedArray,
					};
				}

				// Objeto anidado como ecgi.plmnId.mcc
				const currentField = getNestedField<ConditionObject<any>>(
					condition,
					path,
				);
				if (
					currentField &&
					typeof currentField === 'object' &&
					'notChecked' in currentField
				) {
					const updatedField = {
						...currentField,
						notChecked: !currentField.notChecked,
					};
					return setNestedField(condition, path, updatedField);
				}

				return condition;
			}),
		);
	};

	const copyActiveFlags = (reference: any, target: any): void => {
		for (const key in target) {
			if (
				typeof target[key] === 'object' &&
				target[key] !== null &&
				typeof reference?.[key] === 'object' &&
				reference[key] !== null
			) {
				if ('active' in target[key] && 'active' in reference[key]) {
					target[key].active = reference[key].active;
				}
				copyActiveFlags(reference[key], target[key]);
			}
		}
	};

	const handleAddField = (id: string, field: keyof IConditionForm) => {
		const defaultCondition = defaultFormDataCondition();
		setFormData(prev =>
			prev.map(condition => {
				if (condition.id !== id) return condition;

				// Caso especial: servingNetwork
				if (field === 'servingNetwork') {
					const current = condition.servingNetwork ?? [];
					const newItem: IServingNetwork = {
						mcc: {
							value: '',
							active: true,
							notChecked: false,
							uuid: generateUUID(),
						},
						mnc: {
							value: '',
							active: true,
							notChecked: false,
							uuid: generateUUID(),
						},
					};

					return {
						...condition,
						servingNetwork: [...current, newItem],
					};
				}

				const current = condition[field];
				const defaultField = defaultCondition[field];

				if (Array.isArray(current) && Array.isArray(defaultField)) {
					const ref = current[0];
					const base = structuredClone(defaultField[0]);

					// Distinción: objeto simple o complejo
					if ('value' in base) {
						// Campo simple tipo ConditionObject
						return {
							...condition,
							[field]: [
								...current,
								{
									value: '',
									active: true,
									notChecked: false,
									uuid: generateUUID(),
								},
							],
						};
					} else {
						// Campo complejo tipo tai[], sai[], etc.
						copyActiveFlags(ref, base);
						return {
							...condition,
							[field]: [...current, base],
						};
					}
				}
				return condition;
			}),
		);
	};

	const handleRemoveField = (
		id: string,
		field: keyof IConditionForm,
		index: number,
	) => {
		setFormData(prev =>
			prev.map(condition => {
				if (condition.id !== id) return condition;

				const current = condition[field];
				if (Array.isArray(current)) {
					if (index < 0 || index >= current.length) return condition;
					const newArray = [...current];
					newArray.splice(index, 1);

					return {
						...condition,
						[field]: newArray,
					};
				}
				return condition;
			}),
		);
	};

	/* The above code is a `useEffect` hook that is triggered whenever the `formData` variable changes. It
	creates a copy of the `formData` object, renames some of its properties, and deletes some other
	properties. Then it calls the `onChange` function with the modified object as an argument. The
	purpose of this code is to transform the `formData` object into a format that can be used by
	another part of the codebase. */
	useEffect(() => {
		const tmpArray = formData.map(condition =>
			cleanConditionFormForXML(JSON.parse(JSON.stringify(condition))),
		);

		onChange({
			conditions: tmpArray,
		} as never);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formData]);

	return (
		<div>
			<div className="col m-3">
				<Button
					type="button"
					variant="secondary"
					className="btn btn-labeled btn-sm z-index mr-1"
					onClick={() => handleConditionAdd(false)}>
					<span className="btn-label mr-2">
						<i className="bi-1 bi-plus" />
					</span>
					Group AND
				</Button>

				<Button
					type="button"
					variant="secondary"
					className="btn btn-labeled btn-sm z-index"
					onClick={() => handleConditionAdd(true)}>
					<span className="btn-label mr-2">
						<i className="bi-1 bi-plus" />
					</span>
					Group OR
				</Button>
			</div>
			<Accordion className="accordion-nested">
				{formData.map(condition => {
					const headerLabel = condition.isGroup ? `OR #${++orCount}` : 'AND';
					return (
						<Accordion.Item
							eventKey={`condi${String(condition.id)}`}
							key={`condi${String(condition.id)}`}
							className="rounded border">
							<Accordion.Header className="position-relative">
								{`Group ${headerLabel}`}
								<Button
									type="button"
									variant="secondary"
									className="border-0 bg-transparent btn-sm ml-2 d-inline position-absolute z-index top-0 end-0 pr-2 pt-3"
									onClick={event => {
										event.stopPropagation();
										confirmAlert(removeAccordion(condition.id));
									}}>
									<span className="btn-label">
										<i className="bi-1 bi-trash3-fill invalid-color" />
									</span>
								</Button>
							</Accordion.Header>
							<Accordion.Body className="newBox &gt; px-0">
								<div
									className="container-fluid &gt; px-0"
									style={{height: '70vh', overflow: 'hidden'}}>
									{/* Intro */}
									<div className="rounded-3 mb-4 px-4" style={{height: '100%'}}>
										<div className="row" style={{height: '100%'}}>
											<div className="col-12 col-lg-6 col-xl-5">
												{/* list possible conditions */}
												<div className="row">
													<div className="col-12">
														<CustomListGroupCondition
															options={transformLabelConditions(
																labelConditions,
																typeForm as 'App' | 'Gw',
																isVolTE,
																condition.isGroup,
															)}
															formData={condition}
															onSelect={handleFieldSelect}
															nameDropdown={'Labels enabled'}
														/>
													</div>
												</div>
											</div>
											<div
												className="col-12 col-lg-6 col-xl-7"
												style={{height: '100%'}}>
												<div className="row" style={{height: '100%'}}>
													<div className="col-12" style={{height: '100%'}}>
														<CustomSelectionItemCondition
															formData={condition}
															updateFormData={updateFormData}
															updateNotChecked={updateNotChecked}
															onObserver={onObserver}
															onAddField={handleAddField}
															onRemoveField={handleRemoveField}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Accordion.Body>
						</Accordion.Item>
					);
				})}
			</Accordion>
		</div>
	);
};

export default ConditionForm;
